import { setContext, getContext } from "svelte";
import type { SiteConfig } from "./template-types";

export { cloudinaryUrl, cloudinarySrcset } from "#lib/shared/cloudinary.js";

export function setTemplateContext(readConfig: () => SiteConfig) {
	const context: Readonly<SiteConfig> = {
		get siteUrl() {
			return readConfig().siteUrl;
		},
		get siteName() {
			return readConfig().siteName;
		},
		get siteSlug() {
			return readConfig().siteSlug;
		},
		get siteSlogan() {
			return readConfig().siteSlogan;
		},
		get asHeardOnVendors() {
			return readConfig().asHeardOnVendors;
		},
		get teamMembers() {
			return readConfig().teamMembers;
		},
		get testimonials() {
			return readConfig().testimonials;
		},
		get blogPosts() {
			return readConfig().blogPosts;
		},
		get primaryCity() {
			return readConfig().primaryCity;
		},
		get primaryState() {
			return readConfig().primaryState;
		},
		get serviceArea() {
			return readConfig().serviceArea;
		},
		get contact() {
			return readConfig().contact;
		},
		get googleAnalyticsId() {
			return readConfig().googleAnalyticsId;
		},
		get socialUrls() {
			return readConfig().socialUrls;
		},
		get images() {
			return readConfig().images;
		},
		get servicedAreas() {
			return readConfig().servicedAreas;
		}
	};
	return setContext("TemplateContext", context);
}

export function getTemplateContext() {
	return getContext<ReturnType<typeof setTemplateContext>>("TemplateContext");
}
